import { useEffect } from "react";
import { Reveal } from "../components/Reveal";
import { PageHero } from "../components/Shared";

const CONTENT = {
  avis: {
    label: "Legal",
    title: "Avís legal",
    sections: [
      {
        h: "Titularitat i dades identificatives",
        p: [
          "Orbis Forum Català forma part del grup Danser Strategic Holding Ltd.",
          "· Company Registration núm.: 16284751",
          "· Domicili social: 48 Burtonshire, SW14 8PR, Londres, Regne Unit",
          "L'accés i la utilització d'aquest lloc web impliquen l'acceptació d'aquestes condicions.",
        ],
      },
      {
        h: "Objecte",
        p: [
          "Orbis Forum Català és una entitat privada i independent. No és una administració pública, ni una organització sense ànim de lucre, ni un despatx d'advocats. Els serveis oferts tenen caràcter d'assessorament i consultoria privada.",
        ],
      },
      {
        h: "Propietat intel·lectual",
        p: [
          "Tots els continguts d'aquest lloc web (textos, imatges, marques i disseny) estan protegits pels drets de propietat intel·lectual i industrial. Queda prohibida la seva reproducció total o parcial sense autorització expressa.",
        ],
      },
      {
        h: "Responsabilitat",
        p: [
          "La informació d'aquest lloc web té caràcter general i orientatiu. Orbis Forum Català no es responsabilitza de les decisions preses a partir d'aquesta informació sense un assessorament previ personalitzat.",
        ],
      },
    ],
  },
  privadesa: {
    label: "Legal",
    title: "Política de privadesa",
    sections: [
      {
        h: "Responsable del tractament",
        p: [
          "Orbis Forum Català, part del grup Danser Strategic Holding Ltd. (Company Registration núm. 16284751, amb domicili social a 48 Burtonshire, SW14 8PR, Londres, Regne Unit), és la responsable del tractament de les dades personals facilitades a través del formulari de contacte. Podeu contactar-nos mitjançant el formulari de contacte del lloc web.",
        ],
      },
      {
        h: "Finalitat",
        p: [
          "Les dades que ens proporcioneu (nom, correu electrònic, telèfon i missatge) s'utilitzen exclusivament per atendre la vostra sol·licitud i mantenir la comunicació derivada de la consulta.",
        ],
      },
      {
        h: "Legitimació i conservació",
        p: [
          "La base legal del tractament és el vostre consentiment en enviar el formulari. Les dades es conserven durant el temps necessari per atendre la sol·licitud i complir les obligacions legals aplicables.",
        ],
      },
      {
        h: "Drets",
        p: [
          "Podeu exercir els drets d'accés, rectificació, supressió, oposició, limitació i portabilitat de les vostres dades a través del formulari de contacte del lloc web.",
        ],
      },
    ],
  },
  cookies: {
    label: "Legal",
    title: "Política de cookies",
    sections: [
      {
        h: "Ús de cookies",
        p: [
          "Aquest lloc web està dissenyat per funcionar amb un ús mínim de cookies. No s'utilitzen cookies de publicitat ni de seguiment de tercers amb finalitats comercials.",
        ],
      },
      {
        h: "Cookies tècniques",
        p: [
          "Es poden utilitzar cookies tècniques necessàries per al correcte funcionament del lloc web i per garantir una navegació segura i fluida.",
        ],
      },
      {
        h: "Gestió",
        p: [
          "Podeu configurar el vostre navegador per acceptar o rebutjar les cookies, així com per eliminar-les. La desactivació d'algunes cookies pot afectar el funcionament del lloc.",
        ],
      },
    ],
  },
};

export default function Legal({ variant }) {
  const data = CONTENT[variant] || CONTENT.avis;

  useEffect(() => {
    document.title = `${data.title} — Orbis Forum Català`;
  }, [data.title]);

  return (
    <div>
      <PageHero label={data.label} title={data.title} />
      <section className="border-t border-white/5">
        <div className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28 space-y-12">
          {data.sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <h2 className="font-serif-display text-2xl md:text-3xl mb-4">{s.h}</h2>
              {s.p.map((para, j) => (
                <p key={j} className="text-white/55 font-light leading-relaxed">
                  {para}
                </p>
              ))}
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
